export type LogValue = string | number | boolean | null;
export type LogContext = Readonly<Record<string, LogValue>>;
export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

export interface StructuredLogRecord {
  readonly timestamp: string;
  readonly level: LogLevel;
  readonly subsystem: 'chat' | 'recovery' | 'signaling' | 'stats' | 'webrtc';
  readonly event: string;
  readonly context: LogContext;
}

export interface StructuredLogger {
  write(record: StructuredLogRecord): void;
}

export const NOOP_LOGGER: StructuredLogger = { write: () => undefined };

export class ConsoleStructuredLogger implements StructuredLogger {
  write(record: StructuredLogRecord): void {
    const serialized = JSON.stringify(record);
    switch (record.level) {
      case 'debug':
        console.debug(serialized);
        break;
      case 'info':
        console.info(serialized);
        break;
      case 'warn':
        console.warn(serialized);
        break;
      case 'error':
        console.error(serialized);
        break;
    }
  }
}

export function writeLog(
  logger: StructuredLogger,
  level: LogLevel,
  subsystem: StructuredLogRecord['subsystem'],
  event: string,
  context: LogContext = {},
): void {
  logger.write({ timestamp: new Date().toISOString(), level, subsystem, event, context });
}
